const signIssueRouter = [
  {
    path: '/signIssue/contractSendOut',
    name: 'contractSendOut',
    component: () => import('@/views/user/signIssue/contractSendOut.vue'),
    meta: {
      title: '合同状态'
    }
  },
  {
    path: '/template/templateList',
    name: 'templateList',
    component: () => import('@/views/admin/contractTemplate/templateList/templateList.vue'),
    meta: {
      title: '合同模板'
    }
  },
  {
    path: '/epidemicArea',
    name: 'epidemicArea',
    component: () => import('@/views/admin/contractTemplate/epidemicArea/epidemicArea.vue'),
    meta: { title: '疫情防控专区', companyVerify: true, personVerify: true }
  },
  {
    path: '/generate/fillIn',
    name: 'fillIn',
    component: () => import('@/views/admin/contractTemplate/epidemicArea/generate/fillIn.vue'),
    meta: { title: '填写合同内容', companyVerify: true, personVerify: true }
  },
  {
    path: '/generate/fillnBasic',
    name: 'fillnBasic',
    component: () => import('@/views/admin/contractTemplate/epidemicArea/generate/fillnBasic.vue'),
    meta: { title: '填写合同基本信息', companyVerify: true, personVerify: true }
  },
  {
    path: '/generate/generateCode',
    name: 'generateCode',
    component: () => import('@/views/admin/contractTemplate/epidemicArea/generate/generateCode.vue'),
    meta: { title: '生成二维码', companyVerify: true, personVerify: true }
  },
  {
    path: '/template/preview',
    name: 'preview',
    component: () => import('@/views/admin/contractTemplate/templateAdd/uploadSigningFile/preview.vue'),
    meta: {
      title: '文件预览',
      companyVerify: true,
      personVerify: true
    }
  },
  {
    path: '/template/templateDetail',
    name: 'templateDetail',
    component: () => import('@/views/admin/contractTemplate/templateDetail/templateDetail.vue'),
    meta: {
      title: '合同模板详情',
      companyVerify: true,
      personVerify: true,
      layout: { subPage: true, pageWrap: false }
    }
  },
  {
    path: '/template/templateAdd',
    name: 'templateAdd',
    component: () => import('@/views/admin/contractTemplate/templateAdd/templateAdd.vue'),
    meta: {
      title: '新建模板',
      companyVerify: true,
      personVerify: true,
      layout: { subPage: true, pageWrap: false }
    },
    children: [
      {
        path: '/template/uploadSigningFile',
        name: 'uploadSigningFile',
        component: () => import('@/views/admin/contractTemplate/templateAdd/uploadSigningFile/uploadSigningFile.vue'),
        meta: {
          title: '上传签约文件',
          companyVerify: true,
          personVerify: true
        }
      },
      {
        path: '/template/signingSetting',
        name: 'signingSetting',
        component: () => import('@/views/admin/contractTemplate/templateAdd/signingSetting/signingSetting.vue'),
        meta: {
          title: '签约方设置',
          companyVerify: true,
          personVerify: true
        }
      },
      {
        path: '/template/fillFields',
        name: 'fillFields',
        component: () => import('@/views/admin/contractTemplate/templateAdd/fillFields/fillFields.vue'),
        meta: {
          title: '字段设置',
          companyVerify: true,
          personVerify: true
        }
      },
      {
        path: '/template/templateReview',
        name: 'templateReview',
        component: () => import('@/views/admin/contractTemplate/templateAdd/templateReview/templateReview.vue'),
        meta: {
          title: '模板审阅',
          companyVerify: true,
          personVerify: true
        }
      }
    ]
  },
  {
    path: '/template/fieldManagement',
    name: 'fieldManagement',
    component: () => import('@/views/admin/contractTemplate/fieldManagement/fieldManagement.vue'),
    meta: {
      title: '业务控件管理'
    }
  },
  {
    path: '/template/fieldManageAdd',
    name: 'fieldManageAdd',
    component: () => import('@/views/admin/contractTemplate/fieldManagement/fieldManageAddOrEdit.vue'),
    meta: {
      title: '新增业务字段',
      companyVerify: true,
      personVerify: true
    }
  },
  {
    path: '/template/fieldManageEdit',
    name: 'fieldManageEdit',
    component: () => import('@/views/admin/contractTemplate/fieldManagement/fieldManageAddOrEdit.vue'),
    meta: {
      title: '编辑业务字段',
      companyVerify: true,
      personVerify: true
    }
  },
  {
    path: '/template/typeManagement',
    name: 'typeManagement',
    component: () => import('@/views/admin/contractTemplate/typeManagement/typeManagement.vue'),
    meta: {
      title: '模板类型管理',
      companyVerify: true,
      personVerify: true
    }
  }
]
export default signIssueRouter
